<template>
  <e-sidebar
    id="sidebar-motoboy-presence"
    :title="$t('Presença de Motoboys')"
    :show="show"
    :hide-save-button="true"
    :cancel-button-text="$t('Fechar')"
    :no-close-on-backdrop="false"
    width="30%"
    @hidden="$emit('hidden')"
  >
    <template #content>
      <FormulateInput
        id="motoboy-presence-sidebar_filter"
        v-model="nameFilter"
        type="text"
        :label="$t('Nome')"
        :placeholder="$t('Filtrar por nome')"
      />

      <b-alert
        :show="!filteredMotoboys.length"
        variant="light"
        class="mb-0"
      >
        {{
          motoboys.length
            ? $t('Nenhum Motoboy encontrado para o filtro informado')
            : $t('Não há Motoboys vinculados a esta loja')
        }}
      </b-alert>

      <ul class="motoboy-presence-list list-unstyled mb-0">
        <li
          v-for="motoboy in filteredMotoboys"
          :key="motoboyId(motoboy)"
          class="motoboy-presence-list__item d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <strong>{{ motoboyName(motoboy) }}</strong>
            <b-badge
              :variant="presenceVariant(motoboy)"
              class="ml-50"
            >
              {{ presenceLabel(motoboy) }}
            </b-badge>
          </div>

          <e-button
            v-if="presenceState(motoboy) === 'Absent'"
            :id="`motoboy-presence-sidebar_present-${motoboyId(motoboy)}`"
            size="sm"
            icon="person-check"
            :busy="isPending(motoboy)"
            :text="$t('Marcar presente')"
            @click="changePresence(motoboy, 'Present')"
          />
          <e-button
            v-else-if="presenceState(motoboy) === 'Present'"
            :id="`motoboy-presence-sidebar_absent-${motoboyId(motoboy)}`"
            size="sm"
            variant="outline-secondary"
            icon="person-x"
            :busy="isPending(motoboy)"
            :text="$t('Marcar ausente')"
            @click="changePresence(motoboy, 'Absent')"
          />
          <e-button
            v-else-if="!hasDeliveryInRoute(motoboy)"
            :id="`motoboy-presence-sidebar_release-${motoboyId(motoboy)}`"
            size="sm"
            icon="person-check"
            :busy="isPending(motoboy)"
            :text="$t('Liberar')"
            @click="changePresence(motoboy, 'Present')"
          />
        </li>
      </ul>
    </template>
  </e-sidebar>
</template>

<script>
import { BAlert, BBadge } from 'bootstrap-vue'
import ESidebar from '@/views/components/ESidebar.vue'
import EButton from '@/views/components/EButton.vue'
import { stringUtils } from '@/mixins'
import motoboyPresence from './motoboy-presence'

export default {
  name: 'MotoboyPresenceSidebar',

  components: {
    BAlert,
    BBadge,
    EButton,
    ESidebar,
  },

  mixins: [motoboyPresence, stringUtils],

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      nameFilter: '',
    }
  },

  computed: {
    filteredMotoboys() {
      const term = this.normalizeName(this.nameFilter).trim()
      if (!term) return this.motoboys
      return this.motoboys.filter(motoboy =>
        this.normalizeName(this.motoboyName(motoboy)).includes(term)
      )
    },
  },

  watch: {
    show(value) {
      if (!value) this.nameFilter = ''
    },
  },

  methods: {
    normalizeName(value) {
      return this.getWithNoAccents(value || '').toLowerCase()
    },
  },
}
</script>

<style lang="scss" scoped>
.motoboy-presence-list__item {
  gap: 0.5rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #ebe9f1;

  &:last-child {
    border-bottom: 0;
  }
}
</style>
